module.exports = __webpack_public_path__ + "static/media/IMG-1.cb9de1ba.jpg";